import {allowAddingDocuments, showAnalyticsTabs} from "@/properties.js";
import {
	PM02Projection,
	PlantInfo,
	Reservations,
	Sourcing,
	Description,
	HersRecords,
	Usage,
	WhereUsed,
	MaterialTabs,
	MaintenanceWorks,
} from "@/variants/index.js";

export const MATERIAL_TAB_KEYS = {
	get DESCRIPTION() {
		return Description.tabKey;
	},
	STOCK_ON_HAND: "stock-on-hand",
	PLANT_INFO: "plant-info",
	get USAGE() {
		return Usage?.tabKey ?? "usage";
	},
	WHERE_USED: "where-used",
	DASHBOARD_SUMMARY: "dashboard-summary",
	FOCUS_SUMMARY: "focus-summary",
	TRANSACTIONS: "transactions",
	RESERVATIONS: "reservations",
	SOURCING: "sourcing",
	PM02_PROJECTION: "pm02-projection",
	POTENTIAL_DUPLICATES: "potential-duplicates",
	ATTACHED_DOCUMENTS: "attached-documents",
	get HERS_RECORDS() {
		return HersRecords.tabKey;
	},
};

export function getMaterialTabOptions() {
	const optionsMap = {
		[MATERIAL_TAB_KEYS.DESCRIPTION]: {value: MATERIAL_TAB_KEYS.DESCRIPTION, label: Description.tabTitle},
		[MATERIAL_TAB_KEYS.STOCK_ON_HAND]: {value: MATERIAL_TAB_KEYS.STOCK_ON_HAND, label: "Stock on Hand"},
		[MATERIAL_TAB_KEYS.PLANT_INFO]: PlantInfo.enabled
			? {value: MATERIAL_TAB_KEYS.PLANT_INFO, label: "Plant Info"}
			: null,
		[MATERIAL_TAB_KEYS.USAGE]: {value: MATERIAL_TAB_KEYS.USAGE, label: Usage.tabTitle},
		[MATERIAL_TAB_KEYS.WHERE_USED]: {value: MATERIAL_TAB_KEYS.WHERE_USED, label: WhereUsed.tabTitle},
		[MATERIAL_TAB_KEYS.DASHBOARD_SUMMARY]: showAnalyticsTabs
			? {value: MATERIAL_TAB_KEYS.DASHBOARD_SUMMARY, label: "Dashboard Summary"}
			: null,
		[MATERIAL_TAB_KEYS.FOCUS_SUMMARY]: showAnalyticsTabs
			? {value: MATERIAL_TAB_KEYS.FOCUS_SUMMARY, label: "Focus Summary"}
			: null,
		[MATERIAL_TAB_KEYS.TRANSACTIONS]: {value: MATERIAL_TAB_KEYS.TRANSACTIONS, label: "Transactions"},
		[MATERIAL_TAB_KEYS.RESERVATIONS]: Reservations.enabled
			? {value: MATERIAL_TAB_KEYS.RESERVATIONS, label: "Reservations"}
			: null,
		[MATERIAL_TAB_KEYS.SOURCING]: Sourcing.enabled ? {value: MATERIAL_TAB_KEYS.SOURCING, label: "Sourcing"} : null,
		[MATERIAL_TAB_KEYS.PM02_PROJECTION]: PM02Projection.enabled
			? {value: MATERIAL_TAB_KEYS.PM02_PROJECTION, label: PM02Projection.tabTitle || "PM02 Material Projection"}
			: null,
		[MATERIAL_TAB_KEYS.POTENTIAL_DUPLICATES]: {
			value: MATERIAL_TAB_KEYS.POTENTIAL_DUPLICATES,
			label: "Potential Duplicates",
		},
		[MATERIAL_TAB_KEYS.ATTACHED_DOCUMENTS]: allowAddingDocuments
			? {value: MATERIAL_TAB_KEYS.ATTACHED_DOCUMENTS, label: "Attached Documents"}
			: null,
		[MATERIAL_TAB_KEYS.HERS_RECORDS]: {value: MATERIAL_TAB_KEYS.HERS_RECORDS, label: HersRecords.tabTitle},
	};

	return MaterialTabs.tabOrder.map(key => optionsMap[key]).filter(Boolean);
}

export const EQUIPMENT_TAB_KEYS = {
	INFORMATION: "information",
	BOM: "bom",
	MAINTENANCE: "maintenance",
	PROPOSED_BOM: "proposed-bom",
	ATTACHED_DOCUMENTS: "attached-documents",
};

export function getEquipmentTabOptions() {
	return [
		showAnalyticsTabs ? {value: EQUIPMENT_TAB_KEYS.INFORMATION, label: "Information"} : null,
		{value: EQUIPMENT_TAB_KEYS.BOM, label: "Bill of Material"},
		{value: EQUIPMENT_TAB_KEYS.MAINTENANCE, label: MaintenanceWorks.tabTitle},
		allowAddingDocuments ? {value: EQUIPMENT_TAB_KEYS.ATTACHED_DOCUMENTS, label: "Attached Documents"} : null,
	].filter(Boolean);
}
